import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Zap, Shield, AlertTriangle, Bug, Plug, Ruler } from 'lucide-react';
import { mockData } from '../mock';

const iconMap = {
  Zap,
  Shield,
  AlertTriangle,
  Bug,
  Plug,
  Ruler
};

export const Services = () => {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold text-stone-900">
            Mes Services
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-emerald-600 to-emerald-400 mx-auto rounded-full" />
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Des diagnostics immobiliers complets pour sécuriser votre transaction
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockData.services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <Card 
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-stone-200 hover:border-emerald-300 bg-gradient-to-br from-white to-stone-50/50"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <CardHeader>
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-emerald-100 to-emerald-50 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-7 h-7 text-emerald-700" />
                  </div>
                  <CardTitle className="text-2xl font-bold text-stone-900 group-hover:text-emerald-800 transition-colors">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-emerald-700 font-medium">
                    {service.subtitle}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <p className="text-stone-600 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};